import React, { useState } from "react";
import { Box, BottomNavigation, BottomNavigationAction } from "@mui/material";
import { Home, CardGiftcard, ListAlt, Person } from "@mui/icons-material";
import HomePage from "./Home";
import RewardsPage from "./Rewards";
import MyListPage from "./MyList"; // Import the My List component
import ProfilePage from "./Profile";

const FlashFlicks = () => {
  const [activeTab, setActiveTab] = useState(0);

  return (
    <Box sx={{ backgroundColor: "#000", color: "#fff", minHeight: "100vh" }}>
      {/* Active Component */}
      <Box>
        {activeTab === 0 && <HomePage />}
        {activeTab === 1 && <RewardsPage />}
        {activeTab === 2 && <MyListPage />} {/* Add My List page */}
        {activeTab === 3 && <ProfilePage />}
      </Box>

      {/* Bottom Navigation */}
      <BottomNavigation
        value={activeTab}
        onChange={(event, newValue) => setActiveTab(newValue)}
        sx={{
          position: "fixed",
          bottom: 0,
          left: 0,
          width: "100%",
          backgroundColor: "#111",
          borderTop: "1px solid #333",
        }}
      >
        <BottomNavigationAction
          label="Home"
          icon={<Home />}
          sx={{ color: "#fff", "&.Mui-selected": { color: "#f50057" } }}
        />
        <BottomNavigationAction
          label="Rewards"
          icon={<CardGiftcard />}
          sx={{ color: "#fff", "&.Mui-selected": { color: "#f50057" } }}
        />
        <BottomNavigationAction
          label="My List" // Add the My List tab
          icon={<ListAlt />}
          sx={{ color: "#fff", "&.Mui-selected": { color: "#f50057" } }}
        />
        <BottomNavigationAction
          label="Profile"
          icon={<Person />}
          sx={{ color: "#fff", "&.Mui-selected": { color: "#f50057" } }}
        />
      </BottomNavigation>
    </Box>
  );
};

export default FlashFlicks;